import ResponseCommonModel from './ResponseCommonModel'

/**
 * レスポンスベースモデル
 */
export default class ResponseBaseModel {
  /**
   * 共通部
   */
  common: ResponseCommonModel
}
